import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { UserWallEvent } from '../../../../../../../../graphql/libs/viewer-wall/types';
import { UserWallEventType } from '../../graphql';
import { ZalamoObject } from '../../../../../graphql';

@Component({
    selector: 'app-private-session-deactivated',
    templateUrl: './private-session-deactivated.component.html',
    styleUrls: ['./private-session-deactivated.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivateSessionDeactivatedComponent implements OnInit {
  @Input()
  @ParseJson
  details: UserWallEvent[UserWallEventType.PrivateSessionDeactivated];
  ob: ZalamoObject = ZalamoObject.OrganizationClient;
  constructor() {}

  ngOnInit(): void {}
}
